// extracted by css-extract-rspack-plugin
export default {"clearSearchButton":"clearSearchButton-UckPHa"};